/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * setEnvironmentInfoCommand.js --
 *
 *      This API is added to minimize the change to support:
 *      https://omnissa.atlassian.net/wiki/spaces/CNVDES/pages/41819460/
 *      2018FQ3+-+RDSH+Entitlement+Restriction+Client+Side+Functional+Spec
 *      Where whenever a request is sent, environment info is needed.
 *      Since the environment content never changes and we have too many APIs to
 *      indirectly sending this XML as the first step, use this method to minimize
 *      the changes in both JSCDK, and HTML Access.
 *
 *      p.s. After JSCDK refactor, it should be in a model and shared among
 *      more XMLs with filters.
 */

import { globalArray } from "../jscdkClient";

export default function SetEnvironmentInfoCommand() {}

/**
 * Invoked by JSCDKController
 *
 * @param SetEnvironmentInfoAction[in]
 *        - its property 'method' has the value 'SetEnvironmentInfo'
 */
SetEnvironmentInfoCommand.prototype.execute = function (SetEnvironmentInfoAction) {
   globalArray["environment-information"] = SetEnvironmentInfoAction.data;
};
